import React from "react";
import {textbausteinTypes1} from "../Textbausteine/textbausteinTypes";
import {useSelector} from "react-redux";
import {notenOptions} from "../../data/noten";

const ThreeFields = ({schueler, fieldnames, gewichtung}) => {
  const textbausteine = useSelector(st => st.textbausteine);
  const [first, second, third] = fieldnames;
  if (!(schueler[first] && schueler[second])) return null;
  const tbArr = schueler[second].split(" ").map(i => parseInt(i));
  const localTbs = tbArr.map(i => textbausteine.find(tb => tb.id === i)?.text);
  const note = notenOptions.find(no => parseInt(no.key) === parseInt(schueler[first])).value;
  return (
    <>
      <tr>
        <th colSpan={12}>{`${textbausteinTypes1[second].headline} ${gewichtung ? `(${gewichtung} %)` : ""}`}</th>
        <th> </th>
      </tr>
      <tr>
        <td>Punkte</td>
        <td>{note}</td>
      </tr>
      {localTbs.map((i, idx) => (
        <tr key={i}>
          <td>{idx === 0 ? "Textbausteine" : ""}</td>
          <td>{i}</td>
        </tr>
      ))}
      <tr>
        <td>Bemerkungen</td>
        <td>{schueler[third]}</td>
      </tr>
    </>
  );
};
export default ThreeFields;
